import newRelicAgent from "@web2/providers/scripts/nr-loader-spa.1.252.0.min.js?url";
import { useEffect } from "react";

export function useNewRelic() {
  const id = import.meta.env.VITE_NEW_RELIC_ID as string | undefined;
  const key = import.meta.env.VITE_NEW_RELIC_KEY as string | undefined;
  const isConfigured = !!(id && key);

  useEffect(() => {
    if (!isConfigured || typeof window === "undefined") return;

    // Prevent duplicate loading
    if (window.NREUM_LOADED) return;
    window.NREUM_LOADED = true;

    const config = {
      init: {
        session_replay: {
          enabled: true,
          block_selector: "",
          mask_text_selector: "*",
          sampling_rate: 10.0,
          error_sampling_rate: 100.0,
          mask_all_inputs: true,
          collect_fonts: true,
          inline_images: false,
          inline_stylesheet: true,
          mask_input_options: {},
        },
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.nr-data.net"] },
      },
      loader_config: {
        accountID: "225023",
        trustKey: "225023",
        agentID: id,
        licenseKey: key,
        applicationID: id,
      },
      info: {
        beacon: "bam.nr-data.net",
        errorBeacon: "bam.nr-data.net",
        licenseKey: key,
        applicationID: id,
        sa: 1,
      },
    };

    // Inject init script
    const initScript = document.createElement("script");
    initScript.innerHTML = `
      window.NREUM||(NREUM={});
      NREUM.init=${JSON.stringify(config.init)};
      NREUM.loader_config=${JSON.stringify(config.loader_config)};
      NREUM.info=${JSON.stringify(config.info)};
    `;
    document.head.appendChild(initScript);

    // Load agent script
    const agentScript = document.createElement("script");
    agentScript.src = newRelicAgent;
    agentScript.async = true;
    agentScript.type = "text/javascript";
    document.head.appendChild(agentScript);
  }, [isConfigured, id, key]);

  // Return null for SSR - no JSX elements
  return { NewRelicScripts: null, isConfigured };
}
